module.exports = __webpack_public_path__ + "img/15n.cdfcc7bb.png";